/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FacebookNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABv0lEQVR4nMVVyy4EQRRlgY0Ra/H8DK99h657b0vKvU2EBOMXvIkvsfZY8BESQbASEROR2HrbIjViVJuurhkhKqlN5/Y5dc85t6qm5j8XAOQQ4xlA2QDkKyC+BZIXQD4DlG2FPBEEo01VA+fz+TqFvKqI74DkLWsrlCcgng2CoKEicETuVMQHPmD4TkR8DCAtPvA2IClUCw4lErk2GE5ZAOXEA/KqiHcU8iRErEPkMSNlUjLeT5ULiJf94DJe9h9IS7kvPP+tCHJA/ODReDet8zQCkzbE8WZL+3jGpy9iPGXh1gLJGiDvAfFperp44usUJuc+EyMZtMLQ4zedtywCvvQmJJLA6lhVMB/nJQJF8vgHBE92gp4dbS6kZjppcuSYiccKJGIvgSKZc3RxYZu8/eMOkNcdsd60TsF5R9GNIj40O6S4u1Q/NNz7+T1jfqZLBFrrRp/RKmnygMfg+8SgFVslWfw9Al4q01JrXe+aSqiCwFz15uJMNSyKRls/Xq4fExQGhkY6MlOhlO5Ke3CUjwDlKAx1eyZ4Ui5ZsZ9MF8FHDS87Zcla5kEvRhhlI6S474uA+03Oi7cwQK5q4N9c75IwfHxbcNrQAAAAAElFTkSuQmCC)
 */
export const FacebookNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23 12a11 11 0 1 0-12.72 10.87v-7.69h-2.8V12h2.8V9.58c0-2.76 1.64-4.28 4.16-4.28 1.2 0 2.46.21 2.46.21v2.7H15.5c-1.37 0-1.8.86-1.8 1.73V12h3.06l-.49 3.18h-2.56v7.69A11 11 0 0 0 23 12Z"
        className={colorClass}
      />
    </svg>
  );
};
